const STORAGE_KEY = 'savedCarts';
const MAX_CARTS = 4;

export const getSavedCarts = () => {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    } catch {
        return {};
    }
};

// Save (or overwrite) a cart for a restaurant. Evicts the oldest entry when over limit.
export const saveCart = (restaurantId, slug, name, image, products) => {
    if (!restaurantId || !products || products.length === 0) return;

    const id = String(restaurantId);
    const carts = getSavedCarts();

    carts[id] = {
        restaurantId: Number(restaurantId),
        slug: slug || '',
        name: name || '',
        image: image || '',
        products,
        updatedAt: Date.now(),
    };

    // Enforce max — evict oldest
    const keys = Object.keys(carts);
    if (keys.length > MAX_CARTS) {
        const oldest = keys.sort((a, b) => carts[a].updatedAt - carts[b].updatedAt)[0];
        delete carts[oldest];
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(carts));
};

// Returns the saved products array for a restaurant, or [] if none.
export const loadCartForRestaurant = (restaurantId) => {
    const carts = getSavedCarts();
    return carts[String(restaurantId)]?.products || [];
};

export const deleteCart = (restaurantId) => {
    if (!restaurantId) return;
    const carts = getSavedCarts();
    delete carts[String(restaurantId)];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(carts));
};
